import { number, object, string } from 'superstruct'

export const Country = object({
  id: number(),
  name: string(),
  code: string(),
  federationId: number()
})
